import React from 'react';

import connectionStatusActivityShape from '../../../../../shapes/connection-status-activity';
import ActivityWrapper from '../activity-wrapper';
import { formatUsername } from '../../../../../utils/common';

/**
 * Connection status activity.
 * @param {object} params - Object containing props
 * @param {object} params.activity - Activity to display
 */
const ActivityConnectionStatusUpdated = ({ activity }) => {
  const headerContent = [{
    text: `${formatUsername(activity.initiatorName)} updated the Visibility App connection`,
    descriptor: `${activity.newVisibilityAppStatus}`,
  }];
  return (
    <ActivityWrapper
      type={activity.eventType}
      headerContent={headerContent}
      timestamp={activity.eventTime}
    />
  );
};

ActivityConnectionStatusUpdated.propTypes = {
  activity: connectionStatusActivityShape.isRequired,
};

export default ActivityConnectionStatusUpdated;
